import { useState } from 'react';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const useSecretUnlock = (clicks = 7) => {
  const [count, setCount] = useState(0);
  const [unlocked, setUnlocked] = useState(false);

  const handleClick = () => {
    if (unlocked) return;

    const next = count + 1;
    setCount(next);

    if (next === clicks) {
      setUnlocked(true);
      Toast.fire({ icon: 'success', title: '🔓 Funciones avanzadas activadas' });
    }
  };

  return [unlocked, handleClick];
};

export default useSecretUnlock;
